import { combineReducers } from '@ngrx/store';

import { isLoadingFiltersReducer as isLoadingFilters } from '@flight-results/store/reducers/ui/is-loading-filters.reducer';
import {
  isLoadingFlexDatesReducer as isLoadingFlexDates
} from '@flight-results/store/reducers/ui/is-loading-flex-dates.reducer';
import {
  itinerarySelectedReducer as itinerarySelected
} from '@flight-results/store/reducers/ui/itinerary-selected.reducer';
import {
  isLoadingExchangeReducer as isLoadingExchange
} from '@flight-results/store/reducers/ui/is-loading-exchange.reducer';
import {
  isclearFlightsReducer as isclearFlights
} from '@flight-results/store/reducers/ui/is-clear-flights.reducer';
import {
  isLoadingFlightsScroll
} from '@flight-results/store/reducers/ui/is-loading-scroll.reducer';
import {
  disabledFlightScrollReducer as disabledFlightScroll
} from '@flight-results/store/reducers/ui/disabled-flight-scroll.reducer';
import {
  isLoadingFlightCabinReducer as isLoadingFlightCabin
} from '@flight-results/store/reducers/ui/is-loading-flight-cabin.reducer';
import {
  isLoadingFlightCabinDetailReducer as isLoadingFlightCabinDetail
} from '@flight-results/store/reducers/ui/is-loading-flight-cabin-detail.reducer';
import { showedDetailsReducer as showedDetails } from '@flight-results/store/reducers/ui/showed-details.reducer';
import {
  errorInExchangeBookReducer as errorInExchangeBook
} from '@flight-results/store/reducers/ui/error-in-exchange-book.reducer';
import { successExchangeReducer as successExchange } from '@flight-results/store/reducers/ui/success-exchange.reducer';
import {
  isLoadingExchangePushReducer as isLoadingExchangePush
} from '@flight-results/store/reducers/ui/is-loading-exchange-push.reducer';

export const UiFlightResultsRootReducer = combineReducers({
  isLoadingFilters,
  isLoadingFlexDates,
  itinerarySelected,
  isLoadingExchange,
  isclearFlights,
  isLoadingFlightsScroll,
  disabledFlightScroll,
  isLoadingFlightCabin,
  isLoadingFlightCabinDetail,
  showedDetails,
  errorInExchangeBook,
  successExchange,
  isLoadingExchangePush,
});
